import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { useState, useEffect } from "react";

interface UserInfoStepProps {
  form: UseFormReturn<any>;
}

export function UserInfoStep({ form }: UserInfoStepProps) {
  const [emailError, setEmailError] = useState<string | null>(null);
  const emailValue = form.watch("userEmail");

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Dados do Usuário Admin</h3>
      
      <FormField
        control={form.control}
        name="userName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nome Completo *</FormLabel>
            <FormControl>
              <Input placeholder="Ex: João Silva" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="userEmail"
        render={({ field }) => (
          <FormItem>
            <FormLabel>E-mail *</FormLabel>
            <FormControl>
              <Input type="email" placeholder="usuario@email.com" {...field} />
            </FormControl>
            {emailError && <FormDescription className="text-destructive">{emailError}</FormDescription>}
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="userPhone"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Telefone</FormLabel>
            <FormControl>
              <Input placeholder="(00) 00000-0000" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="userPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Senha *</FormLabel>
            <FormControl>
              <Input type="password" placeholder="Mínimo 6 caracteres" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="confirmPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Confirmar Senha *</FormLabel>
            <FormControl>
              <Input type="password" placeholder="Digite a senha novamente" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
